export default __webpack_public_path__ + "static/media/offices-popup.c123d89a.jpg";